/* eslint-disable @typescript-eslint/no-magic-numbers */
import { LIVE_MAP_CHIP_COLOR_MIX_WEIGHTS } from "./live-map.grid-status-breakdown.constants";

interface IHexRgb {
  r: number;
  g: number;
  b: number;
}

const parseHexRgb = (hex: string): IHexRgb => {
  const raw = hex.replace("#", "").trim();
  const full =
    raw.length === 3
      ? raw
          .split("")
          .map(char => char + char)
          .join("")
      : raw.slice(0, 6);

  const rgb: IHexRgb = {
    r: Number.parseInt(full.slice(0, 2), 16),
    g: Number.parseInt(full.slice(2, 4), 16),
    b: Number.parseInt(full.slice(4, 6), 16),
  };
  return rgb;
};

const toHexChannel = (value: number): string =>
  value.toString(16).padStart(2, "0");

export const mixSrgbHexWithWhite = (
  hex: string,
  colorWeightPercent: number,
): string => {
  const ratio = colorWeightPercent / 100;
  const { r, g, b } = parseHexRgb(hex);
  const mixChannel = (channel: number): number =>
    Math.round(channel * ratio + 255 * (1 - ratio));

  return `#${toHexChannel(mixChannel(r))}${toHexChannel(mixChannel(g))}${toHexChannel(mixChannel(b))}`;
};

export const hexColorToRgba = (hex: string, alpha: number): string => {
  const { r, g, b } = parseHexRgb(hex);
  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
};

export interface ILiveMapDelayStatusChipPalette {
  backgroundColor: string;
  borderColor: string;
  color: string;
  focusOutlineColor: string;
  hoverShadowColor: string;
}

export const buildLiveMapDelayStatusChipPalette = (
  color: string,
): ILiveMapDelayStatusChipPalette => {
  const { border, background, shadow, focusOutline } =
    LIVE_MAP_CHIP_COLOR_MIX_WEIGHTS;

  const palette: ILiveMapDelayStatusChipPalette = {
    borderColor: hexColorToRgba(color, border / 100),
    backgroundColor: mixSrgbHexWithWhite(color, background),
    color,
    hoverShadowColor: hexColorToRgba(color, shadow / 100),
    focusOutlineColor: hexColorToRgba(color, focusOutline / 100),
  };
  return palette;
};
